import styled from "styled-components";

import { Tr } from "commons";

export const TotalRow = styled(Tr)`
    td {
        font-weight: 800;
    }

    @media print {
        padding-bottom: 0;
        td {
            padding-bottom: 0;
        }
    }
`;
